<template>
  <div class="logout">
    <div>
      <v-icon color="primary">account_box</v-icon>
      <span id="userNameTitle" class="logout__title">{{ userName }}</span>
    </div>
    <span id="logoutBtn" class="logout__btn" @click="logout(userName)">Выйти</span>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  created() {
    this.$store.dispatch('GET_USER_INFO')
  },
  computed: {
    userName() {
      return this.$store.state.user.response.fullName
    }
  },
  methods: {
    logout(name) {
      this.$emit('open-modal', name)
    }
  }
}
</script>

<style lang="scss" scoped>
.logout {
  padding-right: 20px;
  text-align: right;
  &__btn {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    text-decoration-line: underline;
    color: #000000;
    cursor: pointer;
  }
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    margin-left: 8px;
    color: #000000;
  }
}
</style>
